import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { SavedListingsProvider } from './context/SavedListingsContext';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Landing from './pages/Landing';
import Home from './pages/Home';
import Search from './pages/Search';
import ListingDetail from './pages/ListingDetail';
import Inquiry from './pages/Inquiry';
import Saved from './pages/Saved';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import ConfirmSignUp from './pages/ConfirmSignUp';
import ForgotPassword from './pages/ForgotPassword';
import AuthCallback from './pages/AuthCallback';
import Dashboard from './pages/Dashboard';
import ListingsManager from './pages/ListingsManager';
import ListingForm from './pages/ListingForm';
import LeadsInbox from './pages/LeadsInbox';
import LeadDetail from './pages/LeadDetail';
import MyProfile from './pages/MyProfile';
import AdminUsers from './pages/AdminUsers';
import AdminAllListings from './pages/AdminAllListings';
import AdminSettings from './pages/AdminSettings';
import AdminReports from './pages/AdminReports';
import AdminRoute from './components/AdminRoute';
import Guide from './pages/Guide';
import ListingsMap from './pages/ListingsMap';
import Compare from './pages/Compare';

function App() {
  return (
    <AuthProvider>
      <SavedListingsProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Landing />} />
              <Route path="listings" element={<Home />} />
              <Route path="listings/map" element={<ListingsMap />} />
              <Route path="listings/compare" element={<Compare />} />
              <Route path="listings/:id" element={<ListingDetail />} />
              <Route path="search" element={<Search />} />
              <Route path="saved" element={<Saved />} />
              <Route path="login" element={<Login />} />
              <Route path="signup" element={<SignUp />} />
              <Route path="confirm" element={<ConfirmSignUp />} />
              <Route path="forgot-password" element={<ForgotPassword />} />
              <Route path="auth/callback" element={<AuthCallback />} />
              <Route path="listings/:id/inquire" element={<Inquiry />} />
              <Route path="guide" element={<Guide />} />
              <Route path="dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="dashboard/profile" element={<ProtectedRoute><MyProfile /></ProtectedRoute>} />
              <Route path="dashboard/listings" element={<ProtectedRoute><ListingsManager /></ProtectedRoute>} />
              <Route path="dashboard/listings/new" element={<ProtectedRoute><ListingForm /></ProtectedRoute>} />
              <Route path="dashboard/listings/edit/:id" element={<ProtectedRoute><ListingForm /></ProtectedRoute>} />
              <Route path="dashboard/all-listings" element={<ProtectedRoute><AdminRoute><AdminAllListings /></AdminRoute></ProtectedRoute>} />
              <Route path="dashboard/users" element={<ProtectedRoute><AdminRoute><AdminUsers /></AdminRoute></ProtectedRoute>} />
              <Route path="dashboard/settings" element={<ProtectedRoute><AdminRoute><AdminSettings /></AdminRoute></ProtectedRoute>} />
              <Route path="dashboard/reports" element={<ProtectedRoute><AdminRoute><AdminReports /></AdminRoute></ProtectedRoute>} />
              <Route path="dashboard/leads" element={<ProtectedRoute><LeadsInbox /></ProtectedRoute>} />
              <Route path="dashboard/leads/entry/:notificationId" element={<ProtectedRoute><LeadDetail /></ProtectedRoute>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </SavedListingsProvider>
    </AuthProvider>
  );
}

export default App;
